import { render } from "./MaterialButton.vue?vue&type=template&id=56a80b99"
import script from "./MaterialButton.vue?vue&type=script&lang=js"
export * from "./MaterialButton.vue?vue&type=script&lang=js"

import "./MaterialButton.vue?vue&type=style&index=0&id=56a80b99&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__